import React from "react";
import classnames from "classnames";
import moment from "moment";
import PropTypes from "prop-types";
import Datepicker from "rialto-icons/Datepicker";

import { isMobileDevice } from "utils";

import styles from "./DateTimeInput.css";

const DateTimeInput = ({ date, isRequired, onChange, onClick }) => (
  <div className={styles.root}>
    <Datepicker size="small" />
    <input
      className={classnames(styles.input, { [styles.required]: isRequired })}
      onChange={(e) => (isMobileDevice() ? () => null : onChange("date", e.target.value))}
      onClick={isMobileDevice() ? () => null : onClick}
      readOnly={!isMobileDevice()}
      type={isMobileDevice() ? "date" : "text"}
      value={isMobileDevice() ? date : date && moment(date).format("L")}
    />
  </div>
);

DateTimeInput.propTypes = {
  date: PropTypes.instanceOf(Date),
  onClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
};

export default DateTimeInput;
